import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "eurolaw_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        if (status === 401) {
            setToken(null);
        }
        // Normalise usage-limit-reached responses so callers can render the
        // same "You've hit your monthly credit limit, upgrade or wait" UI.
        if (status === 402 || status === 429) {
            const d = err?.response?.data;
            const detail = (d && typeof d === "object" ? d.detail : d) || {};
            err.limitReached = true;
            err.limitReason = typeof detail === "string" ? detail : detail.message;
            err.limitBucket = detail?.bucket;
        }
        return Promise.reject(err);
    },
);
